"use strict";

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var colorUtil = require('../../util/color');

var getClassNameByProps = function getClassNameByProps(props) {
  return _.compact([props.getClassName('color-picker-input-ctrl'), props.disabled ? 'disabled' : null, props.selected ? 'selected' : null, getLuminance(props.value, props.opacity / 100) > 0.5 ? 'light' : 'dark']).join(' ');
};

function getBackgroundFromProps(props) {
  if (_.includes(props.value, 'rgb') || props.value === 'transparent' || props.value === 'noColor' || props.value === '') {
    return props.value;
  } else if (colorUtil.isHexString(props.value)) {
    return colorUtil.hexToRgbaCss(props.value, props.opacity / 100);
  }

  return '';
}

function tryGetRgbFromStringValue(value, opacity) {
  var isRgbString = colorUtil.isRgbString,
      parseRgbString = colorUtil.parseRgbString,
      applyOpacity = colorUtil.applyOpacity,
      isHexString = colorUtil.isHexString,
      hexToRgb = colorUtil.hexToRgb;

  if (isRgbString(value)) {
    var _rgb$alpha;

    var rgb = parseRgbString(value);
    return applyOpacity(rgb, (_rgb$alpha = rgb.alpha) !== null && _rgb$alpha !== void 0 ? _rgb$alpha : 1);
  } else if (isHexString(value)) {
    var _rgb = hexToRgb(value);

    return applyOpacity(_rgb, opacity);
  }

  return undefined;
}

function getLuminance(value, opacity) {
  var rgb = tryGetRgbFromStringValue(value, opacity);

  if (!rgb) {
    return 1;
  }

  return colorUtil.getLuminance(rgb);
}

var ColorPickerInput = function ColorPickerInput(props) {
  return React.createElement('div', {
    onClick: props.disabled ? _.noop : props.onClick,
    className: getClassNameByProps(props),
    style: {
      backgroundColor: getBackgroundFromProps(props)
    },
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  }, props.symbol ? React.createElement('div', {
    className: 'color-picker-input-symbol-wrapper'
  }, React.createElement(props.symbol)) : undefined);
};

ColorPickerInput.displayName = displayNames.COLOR_PICKER_INPUT;
ColorPickerInput.propTypes = {
  value: PropTypes.string,
  opacity: PropTypes.number,
  onClick: PropTypes.func,
  symbol: PropTypes.element
};
ColorPickerInput.defaultProps = {
  value: '#ffffff',
  opacity: 100,
  onClick: _.noop
};
module.exports = compose(ColorPickerInput);